import { styledStitches } from "@/app/design-system/styles/stitches.config";

export const TextArea = styledStitches("textarea", {
  br: 4,
  border: "1px solid",
  borderColor: "$neutral7",
  fontSize: 16,
});
